/**
 * @generated SignedSource<<d4a5de047dc708886fdd9d9f95771dc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SaveResetViewSettingsButtonCollapsible$data = {
  readonly isViewConfigModified: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonUI">;
  readonly " $fragmentType": "SaveResetViewSettingsButtonCollapsible";
};
export type SaveResetViewSettingsButtonCollapsible$key = {
  readonly " $data"?: SaveResetViewSettingsButtonCollapsible$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonCollapsible">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "settings"
    }
  ],
  "kind": "Fragment",
  "name": "SaveResetViewSettingsButtonCollapsible",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SaveResetViewSettingsButtonUI"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "settings",
          "variableName": "settings"
        }
      ],
      "kind": "ScalarField",
      "name": "isViewConfigModified"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "47d082e0772298390cd17586b8b85111";

export default node;
